import { Box, Menu } from '@byecode/ui'
import type { BlockType, EVENT_TYPE, FieldInputType } from '@lighthouse/core'
import { blockEventMap, eventTypeName, inputTypeEventMap, TagIcon } from '@lighthouse/shared'
import React, { useCallback, useMemo, useState } from 'react'

export interface EventAdderProps {
    blockType: BlockType | 'page'
    field?: {
        inputType: FieldInputType
    }
    addedEventTypes?: EVENT_TYPE[]
    addEvent: (eventType: EVENT_TYPE) => void
}

export const EventAdder: React.FC<EventAdderProps> = ({ blockType, field, addedEventTypes, addEvent }) => {
    const [opened, setOpened] = useState(false)
    const eventTList = useMemo(() => {
        if (blockType === 'field' && field?.inputType) {
            return inputTypeEventMap[field?.inputType]
        }
        return blockEventMap[blockType as BlockType]
    }, [blockType, field?.inputType])

    const handleClick = useCallback(
        (eventType: EVENT_TYPE) => {
            addEvent(eventType)
            setOpened(false)
        },
        [addEvent]
    )

    return (
        <Box onClick={e => e.stopPropagation()}>
            <Menu position="bottom-end" width={200} opened={opened} onChange={setOpened}>
                <Menu.Target>
                    <TagIcon icon="Add" size={24} enableHover hoverBackground="#26415A0F" color="var(--color-gray-400)" radius={4} />
                </Menu.Target>
                <Menu.Dropdown>
                    {eventTList.map(eventType => {
                        return (
                            <Menu.Item
                                key={eventType}
                                disabled={addedEventTypes?.includes(eventType)}
                                onClick={() => handleClick(eventType)}
                            >
                                {eventTypeName[eventType]}
                            </Menu.Item>
                        )
                    })}
                </Menu.Dropdown>
            </Menu>
        </Box>
    )
}
